import React, { useEffect, useState } from 'react';
import restaurantBanner from 'assets/images/restuarant-banner.png';
import restaurantLogo from 'assets/images/restuarant-logo.png';
import { ENUM_ORDERS_TYPE } from 'utils/enum';
import { BrandType } from 'models/brand.model';
import {
  calculateReactivationTime,
  getCountdownWords,
  isBrandOpenNow,
  openingTime
} from 'utils/functions';

type Props = {
  orderCount?: number;
  restaurant: BrandType;
  orderType: ENUM_ORDERS_TYPE;
  onOpen: (restaurant: BrandType, orderType: ENUM_ORDERS_TYPE) => void;
};

const RestaurantCard = ({ orderCount, restaurant, orderType, onOpen }: Props) => {
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [reactivationTime, setReactivationTime] = useState(
    calculateReactivationTime(restaurant.reactivation_time)
  );

  const open = () => {
    onOpen(restaurant, orderType);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const time = calculateReactivationTime(restaurant.reactivation_time);
      setReactivationTime(time);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [restaurant.reactivation_time]);

  useEffect(() => {
    if (restaurant.is_busy && reactivationTime > 0) {
      setIsBrandOpen(false);
    } else {
      setIsBrandOpen(isBrandOpenNow(restaurant));
    }
  }, [reactivationTime]);

  return (
    <>
      {isBrandOpen ? (
        <div className='cursor-pointer' onClick={open}>
          <div className='relative rounded-lg bg-white shadow-[0px_3px_10px_0px_rgba(100,_102,_104,_0.10)] overflow-hidden'>
            <img
              src={restaurant?.images[0] || restaurantBanner}
              alt='restuarant-banner'
              className='w-full aspect-video object-cover'
            />
            <div className='w-full flex items-start gap-3 p-4'>
              <img
                src={restaurant?.logo || restaurantLogo}
                alt='restuarant-logo'
                className='w-[42px] h-[42px] rounded-full'
              />
              <article>
                <h6 className='font-medium'>{restaurant.name}</h6>
                <p className='text-[#6F7376] text-sm line-clamp-1'>{restaurant.description}</p>
              </article>
              {orderCount ? (
                <div className='shrink-0 w-6 h-6 my-auto ml-auto rounded-full bg-red-5 items-center flex justify-center shadow-lg'>
                  <p className='text-white text-sm font-medium'>{orderCount}</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div
          className='relative rounded-lg bg-white shadow-[0px_3px_10px_0px_rgba(100,_102,_104,_0.10)] overflow-hidden cursor-not-allowed'
          onClick={open}>
          <div className='relative z-0'>
            <img
              src={restaurant?.images[0] || restaurantBanner}
              alt='restuarant-banner'
              className='w-full aspect-video object-cover brightness-[30%]'
            />
            {restaurant.is_busy ? (
              <div className='absolute w-full h-full flex flex-col justify-center items-center top-0 left-0'>
                <p className='font-medium text-2xl text-white text-center'>Busy</p>

                <p className='text-white text-center'>
                  {restaurant.reactivation_time
                    ? `Back in ${getCountdownWords(restaurant.reactivation_time)}`
                    : 'Back soon'}
                </p>
              </div>
            ) : (
              <div className='absolute w-full h-full flex flex-col justify-center items-center top-0 left-0'>
                <p className='font-medium text-2xl text-white text-center'>Closed</p>
                <p className='text-white text-center'>Opens {openingTime(restaurant)}</p>
              </div>
            )}
          </div>
          <div className='w-full flex items-start gap-3 p-4'>
            <img
              src={restaurant?.logo || restaurantLogo}
              alt='restuarant-logo'
              className='w-[42px] h-[42px] rounded-full'
            />
            <article>
              <h6 className='font-medium'>{restaurant.name}</h6>
              <p className='text-[#6F7376] text-sm line-clamp-1'>{restaurant.description}</p>
            </article>
            {orderCount ? (
              <div className='shrink-0 w-6 h-6 my-auto ml-auto rounded-full bg-red-5 items-center flex justify-center shadow-lg'>
                <p className='text-white text-sm font-medium'>{orderCount}</p>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

export default RestaurantCard;
